<template>
  <div>
    <v-layout row wrap class="mb-4">
      <v-btn round color="primary" @click.prevent="doBack">
        <v-icon left dark>mdi-chevron-left</v-icon>
        Back
      </v-btn>
    </v-layout>
    <v-card>
      <v-card-title>
        <div>
          <h3 class="headline mb-0">{{labels.applicant}}</h3>
        </div>
      </v-card-title>
      <v-card-text>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex lg6 xs12>
              <v-radio-group row :label="labels.appIntStat" v-model="motorForm.applicant.appIntStat" :disabled="lockAppIntStat" :error-messages="errors.collect('appIntStat')" data-vv-name="appIntStat" :data-vv-as="labels.appIntStat" v-validate="'required'" @change="doAppIntStat">
                <v-radio v-for="status in appIntStatList" :key="status.value" :label="status.label" :value="status.value"></v-radio>
              </v-radio-group>
            </v-flex>
            <v-flex lg6 xs12>
            </v-flex>
            <v-flex lg6 xs12 v-if="motorForm.applicant.appIntStat === 'I'">
              <!-- Note: Has to add key to field for these condition show/hide field. If not vee-validate will still validate it when you show it after hiding it for the 1st time -->
              <!-- https://vuejs.org/v2/guide/conditional.html#Controlling-Reusable-Elements-with-key -->
              <v-text-field key="appName" v-model="motorForm.applicant.appName" :label="labels.appName" :error-messages="errors.collect('appName')" data-vv-name="appName" :data-vv-as="labels.appName" v-validate="'required|name|max:50'"></v-text-field>
            </v-flex>
            <v-flex lg6 xs12 v-if="motorForm.applicant.appIntStat === 'I'">
            </v-flex>
            <v-flex lg12 xs12 v-if="motorForm.applicant.appIntStat === 'I'">
              <v-checkbox :label="labels.appIsDrv" v-model="motorForm.applicant.appIsDrv" @change="doCopyName" :hint="getPermitStatusLabel(isDrvStatus)" :persistent-hint="true" :class="getPermitStatusClass(isDrvStatus)"></v-checkbox>
            </v-flex>
            <v-flex lg6 xs12 v-if="motorForm.applicant.appIntStat === 'E'">
              <v-text-field key="coyName" v-model="motorForm.applicant.coyName" :label="labels.coyName" :error-messages="errors.collect('coyName')" data-vv-name="coyName" :data-vv-as="labels.coyName" v-validate="'required|name|max:50'"></v-text-field>
            </v-flex>
            <v-flex lg6 xs12 v-if="motorForm.applicant.appIntStat === 'E'">
              <v-text-field v-model="motorForm.applicant.coyRocUen" :label="labels.coyRocUen" :error-messages="errors.collect('coyRocUen')" data-vv-name="coyRocUen" :data-vv-as="labels.coyRocUen" v-validate="'entry|max:20'"></v-text-field>
            </v-flex>
            <v-flex lg6 xs12 v-if="motorForm.applicant.appIntStat === 'E'">
              <v-text-field v-model="motorForm.applicant.coyNature" :label="labels.coyNature" :error-messages="errors.collect('coyNature')" data-vv-name="coyNature" :data-vv-as="labels.coyNature" v-validate="'entry|max:128'"></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
    <v-card key="indDriver" class="mt-3" v-if="motorForm.applicant.appIntStat === 'I'">
      <v-card-title>
        <div>
          <h3 class="headline">{{labels.mainDriver}}</h3>
        </div>
      </v-card-title>
      <v-card-text>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex lg6 xs12>
              <v-text-field v-model="driver.drvName" :label="labels.drvName" :error-messages="errors.collect('drvName')" data-vv-name="drvName" :data-vv-as="labels.drvName" v-validate="'required|name|max:128'" :readonly="motorForm.applicant.appIsDrv"></v-text-field>
            </v-flex>
            <v-flex lg6 xs12>
              <v-text-field v-uppercase="driver.drvNricPassport" v-model="driver.drvNricPassport" :label="labels.drvNricPassport" :error-messages="errors.collect('drvNricPassport')" data-vv-name="drvNricPassport" :data-vv-as="labels.drvNricPassport" v-validate="'required|alpha_num|max:20'"></v-text-field>
            </v-flex>
            <v-flex lg6 xs12>
              <v-text-field v-int-mask="{intScale: 3}" v-model="driver.drvExp" :label="labels.drvExp" :error-messages="errors.collect('drvExp')" data-vv-name="drvExp" :data-vv-as="labels.drvExp" v-validate="'required|numeric|max_value:999|min_value:0'" :hint="getPermitStatusLabel(drvExpStatus)" :persistent-hint="true" :class="getPermitStatusClass(drvExpStatus)"></v-text-field>
            </v-flex>
            <v-flex lg6 xs12>
              <v-autocomplete :items="maritalStatus" v-model="driver.drvMarital" :label="labels.drvMarital" item-text="label" item-value="value" data-vv-name="drvMarital" :data-vv-as="labels.drvMarital" :error-messages="errors.collect('drvMarital')" v-validate="'required'"></v-autocomplete>
            </v-flex>
            <v-flex lg6 xs12>
              <v-radio-group v-model="driver.drvGender" row :label="labels.drvGender" :error-messages="errors.collect('drvGender')" data-vv-name="drvGender" :data-vv-as="labels.drvGender" v-validate="'required'">
                <v-radio v-for="gender in genders" :key="gender.value" :label="gender.label" :value="gender.value"></v-radio>
              </v-radio-group>
            </v-flex>
            <v-flex lg6 xs12>
              <cal-picker v-model="driver.drvDob" :label="labels.drvDob" v-validate="'required'" :data-vv-as="labels.drvDob" data-vv-name="drvDob" :error-messages="errors.collect('drvDob')" :hint="getPermitStatusLabel(drvAgeStatus)" :clazz="getPermitStatusClass(drvAgeStatus)"></cal-picker>
            </v-flex>
            <v-flex lg6 xs12 v-if="$mode !== 'ecics'">
              <v-radio-group v-model="driver.drvOccupation" row :label="labels.drvOccupation" :error-messages="errors.collect('drvOccupation')" data-vv-name="drvOccupation" :data-vv-as="labels.drvOccupation" v-validate="'required'">
                <v-radio v-for="occupation in occupations" :key="occupation.value" :label="occupation.label" :value="occupation.value"></v-radio>
              </v-radio-group>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
    <v-card key="entityDriver" class="mt-3" v-else-if="motorForm.applicant.appIntStat === 'E' && $mode === 'ecics'">
      <v-card-title>
        <div>
          <h3 class="headline">{{labels.mainDriver}}</h3>
        </div>
      </v-card-title>
      <v-card-text>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex lg6 xs12>
              <v-text-field v-model="driver.drvName" :label="labels.drvName" :error-messages="errors.collect('drvName')" data-vv-name="drvName" :data-vv-as="labels.drvName" v-validate="'name|max:128'" :readonly="motorForm.applicant.appIsDrv"></v-text-field>
            </v-flex>
            <v-flex lg6 xs12>
              <v-text-field v-uppercase="driver.drvNricPassport" v-model="driver.drvNricPassport" :label="labels.drvNricPassport" :error-messages="errors.collect('drvNricPassport')" data-vv-name="drvNricPassport" :data-vv-as="labels.drvNricPassport" v-validate="'entry|max:20'"></v-text-field>
            </v-flex>
            <v-flex lg6 xs12>
              <v-text-field v-int-mask="{intScale: 3}" v-model="driver.drvExp" :label="labels.drvExp" :error-messages="errors.collect('drvExp')" data-vv-name="drvExp" :data-vv-as="labels.drvExp" v-validate="'numeric|max_value:999|min_value:0'" :hint="getPermitStatusLabel(drvExpStatus)" :persistent-hint="true" :class="getPermitStatusClass(drvExpStatus)"></v-text-field>
            </v-flex>
            <v-flex lg6 xs12>
              <v-autocomplete :items="maritalStatus" v-model="driver.drvMarital" :label="labels.drvMarital" item-text="label" item-value="value" data-vv-name="drvMarital" :data-vv-as="labels.drvMarital" :error-messages="errors.collect('drvMarital')"></v-autocomplete>
            </v-flex>
            <v-flex lg6 xs12>
              <v-radio-group v-model="driver.drvGender" row :label="labels.drvGender" :error-messages="errors.collect('drvGender')" data-vv-name="drvGender" :data-vv-as="labels.drvGender">
                <v-radio v-for="gender in genders" :key="gender.value" :label="gender.label" :value="gender.value"></v-radio>
              </v-radio-group>
            </v-flex>
            <v-flex lg6 xs12>
              <cal-picker v-model="driver.drvDob" :label="labels.drvDob" :data-vv-as="labels.drvDob" data-vv-name="drvDob" :error-messages="errors.collect('drvDob')" :hint="getPermitStatusLabel(drvAgeStatus)" :clazz="getPermitStatusClass(drvAgeStatus)"></cal-picker>
            </v-flex>
            <v-flex lg6 xs12 v-if="$mode !== 'ecics'">
              <v-radio-group v-model="driver.drvOccupation" row :label="labels.drvOccupation" :error-messages="errors.collect('drvOccupation')" data-vv-name="drvOccupation" :data-vv-as="labels.drvOccupation">
                <v-radio v-for="occupation in occupations" :key="occupation.value" :label="occupation.label" :value="occupation.value"></v-radio>
              </v-radio-group>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
    <v-layout row wrap class="pt-3">
      <v-btn round color="primary" @click.prevent="doBack">
        <v-icon left dark>mdi-chevron-left</v-icon>
        Back
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn round color="primary" type="submit" @click.prevent="doProceed">
        Next
        <v-icon right dark>mdi-chevron-right</v-icon>
      </v-btn>
    </v-layout>
  </div>
</template>

<script>
import clone from 'clone'
import { AGENCY_QUOTATION_LIFECYCLE, QUOTE_MOTOR_DRIVER } from '@/store/types'
import { mtrOccupation } from '@/const/underwriting/motor'
import { maritalStatus, gender, applicantStatus } from '@/const/underwriting'
import MessageMixin from '@/mixins/message'
import { SaveQuoteMixin } from '../../shared/saveQuoteMixin'
import toDate from 'date-fns/toDate'
import { yearDiff } from '@/utils/date'
import { isDrvStatus, drvExpStatus, drvAgeStatus } from './permStatus'

export default {
  data() {
    return {
      labels: {
        applicant: 'Applicant',
        appIntStat: 'Applicant Status*',
        appName: 'Name as in NRIC/Passport*',
        coyName: 'Name of Company*',
        coyRocUen: 'ROC/UEN',
        coyNature: 'Nature of Business',
        appIsDrv: 'Is the Applicant driving?',
        mainDriver: 'Main Driver',
        drvName: 'Name as in NRIC/Passport*',
        drvNricPassport: 'NRIC/Passport*',
        drvDob: 'Date of Birth*',
        drvExp: 'Driving Experience*',
        drvGender: 'Gender*',
        drvOccupation: 'Occupation*',
        drvMarital: 'Marital Status*'
      },
      motorForm: {
        applicant: {
          appIntStat: undefined,
          appSalutation: undefined,
          appName: undefined,
          appNricPassport: undefined,
          appDob: undefined,
          appGender: undefined,
          appOccupation: undefined,
          appEmail: undefined,
          appMobileNo: undefined,
          appTelNo1: undefined,
          appTelNo2: undefined,
          appPostalCode: undefined,
          appAdd1: undefined,
          appAdd2: undefined,
          appAdd3: undefined,
          appAdd4: undefined,
          mailAdd: undefined,
          mailPostalCode: undefined,
          mailAdd1: undefined,
          mailAdd2: undefined,
          mailAdd3: undefined,
          mailAdd4: undefined,
          coyName: undefined,
          coyRocUen: undefined,
          coyNature: undefined,
          appIsDrv: undefined
        },
        drivers: []
      },
      driver: {
        drvName: undefined,
        drvNricPassport: undefined,
        drvDob: undefined,
        drvExp: undefined,
        drvGender: undefined,
        drvOccupation: undefined,
        drvMarital: undefined
      }
    }
  },
  computed: {
    quoteParam() {
      return this.$store.state.agency.quotation.motorParam
    },
    globalForm() {
      return this.$store.state.agency.quotation.motorForm
    },
    globalCommonForm() {
      return this.$store.state.agency.quotation.commonForm
    },
    appIntStatList() {
      // Convert object to arr
      let result = []
      Object.keys(applicantStatus).forEach(function (key) {
        const status = applicantStatus[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    maritalStatus() {
      let result = []
      Object.keys(maritalStatus).forEach(function (key) {
        const status = maritalStatus[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    genders() {
      let result = []
      Object.keys(gender).forEach(function (key) {
        const status = gender[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    occupations() {
      let result = []
      Object.keys(mtrOccupation).forEach(function (key) {
        const status = mtrOccupation[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    lockAppIntStat() {
      // Check for permAppStat from tariff
      let result = false
      if (this.quoteParam.tariff && this.quoteParam.tariff.length > 0 && this.globalForm.tariff) {
        const filter = this.quoteParam.tariff.filter(tariff => tariff.value === this.globalForm.tariff)
        if (filter && filter.length > 0) {
          const tariff = filter[0]
          if (tariff.permAppStat !== null) {
            result = !tariff.permAppStat
          }
        }
      }
      return result
    },
    isDrvStatus() {
      if (this.motorForm.applicant.appIsDrv !== null) {
        return isDrvStatus(this.motorForm.applicant.appIsDrv)
      } else {
        return 'A'
      }
    },
    drvExpStatus() {
      if (this.driver.drvExp !== null) {
        return drvExpStatus(this.driver.drvExp)
      } else {
        return 'A'
      }
    },
    drvAgeStatus() {
      if (this.driver.drvDob !== null) {
        const drvAge = yearDiff(this.globalCommonForm.startDate, this.driver.drvDob)
        return drvAgeStatus(drvAge)
      } else {
        return 'A'
      }
    }
  },
  watch: {
    'motorForm.applicant.appName': function (value) {
      if (this.motorForm.applicant.appIsDrv) {
        this.driver.drvName = value
      }
    }
  },
  methods: {
    doInit() {
      // Default value from vuex store 1st

      // Applicant
      const { applicant } = this.globalCommonForm
      this.motorForm.applicant.appIntStat = applicant.appIntStat
      this.motorForm.applicant.appSalutation = applicant.appSalutation
      this.motorForm.applicant.appName = applicant.appName
      this.motorForm.applicant.appGender = applicant.appGender
      this.motorForm.applicant.appNricPassport = applicant.appNricPassport
      if (applicant.appDob) {
        this.motorForm.applicant.appDob = toDate(applicant.appDob)
      }
      this.motorForm.applicant.appOccupation = applicant.appOccupation
      this.motorForm.applicant.appEmail = applicant.appEmail
      this.motorForm.applicant.appMobileNo = applicant.appMobileNo
      this.motorForm.applicant.appTelNo1 = applicant.appTelNo1
      this.motorForm.applicant.appTelNo2 = applicant.appTelNo2
      this.motorForm.applicant.appPostalCode = applicant.appPostalCode
      this.motorForm.applicant.appAdd1 = applicant.appAdd1
      this.motorForm.applicant.appAdd2 = applicant.appAdd2
      this.motorForm.applicant.appAdd3 = applicant.appAdd3
      this.motorForm.applicant.appAdd4 = applicant.appAdd4
      this.motorForm.applicant.mailAdd = applicant.mailAdd
      this.motorForm.applicant.mailPostalCode = applicant.mailPostalCode
      this.motorForm.applicant.mailAdd1 = applicant.mailAdd1
      this.motorForm.applicant.mailAdd2 = applicant.mailAdd2
      this.motorForm.applicant.mailAdd3 = applicant.mailAdd3
      this.motorForm.applicant.mailAdd4 = applicant.mailAdd4
      this.motorForm.applicant.coyName = applicant.coyName
      this.motorForm.applicant.coyRocUen = applicant.coyRocUen
      this.motorForm.applicant.coyNature = applicant.coyNature
      this.motorForm.applicant.appIsDrv = applicant.appIsDrv

      // Drivers
      this.motorForm.drivers = clone(this.globalForm.drivers)
      if (this.motorForm.drivers && this.motorForm.drivers.length > 0) {
        const driver = this.motorForm.drivers[0]

        this.driver.drvName = driver.drvName
        this.driver.drvNricPassport = driver.drvNricPassport
        if (driver.drvDob) {
          this.driver.drvDob = toDate(driver.drvDob)
        }
        this.driver.drvExp = driver.drvExp
        this.driver.drvGender = driver.drvGender
        this.driver.drvOccupation = driver.drvOccupation
        this.driver.drvMarital = driver.drvMarital
      }

      if (this.lockAppIntStat) {
        // When locked, default to Individual no matter what
        this.motorForm.applicant.appIntStat = 'I'
      } else {
        if (!this.motorForm.applicant.appIntStat && this.appIntStatList && this.appIntStatList.length > 0) {
          // Default 1st value if not found
          this.motorForm.applicant.appIntStat = this.appIntStatList[0].value
        }
      }

      if (this.motorForm.applicant.appIsDrv === undefined) {
        this.motorForm.applicant.appIsDrv = true
      }
    },
    doCopyName() {
      if (this.motorForm.applicant.appIsDrv) {
        this.driver.drvName = this.motorForm.applicant.appName
      }
    },
    doAppIntStat() {
      // Reset some values
      if (this.motorForm.applicant.appIntStat && this.motorForm.applicant.appIntStat === 'E') {
        this.motorForm.applicant.appIsDrv = false
        this.motorForm.applicant.appName = undefined

        // Now going to show main driver even if its entity. Validation turns to non-mandatory
        // Reset Driver
        // this.driver.drvName = undefined
        // this.driver.drvNricPassport = undefined
        // this.driver.drvDob = undefined
        // this.driver.drvExp = undefined
        // this.driver.drvGender = undefined
        // this.driver.drvOccupation = undefined
        // this.driver.drvMarital = undefined
      } else if (this.motorForm.applicant.appIntStat && this.motorForm.applicant.appIntStat === 'I') {
        this.motorForm.applicant.coyName = undefined
        this.motorForm.applicant.coyRocUen = undefined
        this.motorForm.applicant.coyNature = undefined
      }
    },
    doBack() {
      this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 1)
      this.$router.push({ name: 'motorQuote' })
    },
    doProceed() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.$mode === 'ecics') {
            // push main driver into drivers arr
            if (this.driver.drvName || this.driver.drvNricPassport || this.driver.drvDob || this.driver.drvExp || this.driver.drvGender || this.driver.drvOccupation || this.driver.drvMarital) {
              if (this.motorForm.drivers.length === 0) {
                this.motorForm.drivers.push(this.driver)
              } else {
                this.motorForm.drivers[0] = this.driver
              }
            } else if (this.motorForm.drivers.length !== 0) {
              this.motorForm.drivers.splice(0, 1)
            }
          } else {
            if (this.motorForm.applicant.appIntStat === 'I') {
              if (this.motorForm.drivers.length === 0) {
                this.motorForm.drivers.push(this.driver)
              } else {
                this.motorForm.drivers[0] = this.driver
              }
            }
          }

          if (this.motorForm.applicant.appIntStat === 'I') {
            // Some data massage
            if (this.motorForm.applicant.appIsDrv === undefined || this.motorForm.applicant.appIsDrv === null) {
              this.motorForm.applicant.appIsDrv = false
            }
          }

          this.$store.commit(QUOTE_MOTOR_DRIVER, this.motorForm)
          this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 3)
          this.$router.push({ name: 'motorQuoteVehicle' })
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doPartialSave() {
      // No mandatory validation here. Commit whatever thats on screen and do neccesary actions before saving
      // Must return true/false
      try {
        // push main driver into drivers arr
        if (this.motorForm.applicant.appIntStat === 'I') {
          if (this.motorForm.drivers.length === 0) {
            this.motorForm.drivers.push(this.driver)
          } else {
            this.motorForm.drivers[0] = this.driver
          }
        } else {
          this.motorForm.drivers = []
        }
        this.$store.commit(QUOTE_MOTOR_DRIVER, this.motorForm)
        await this.$store.dispatch('saveQuote')
        return true
      } catch (err) {
        return false
      }
    }
  },
  beforeMount() {
    // Check quote lifecycle (might be using back link or url)
    if (this.$store.state.agency.quotation.quoteLifeCycle !== 2) {
      this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 2)
    }
    this.doInit()
  },
  mixins: [
    MessageMixin,
    SaveQuoteMixin
  ],
  props: {
    getPermitStatusLabel: {
      type: Function,
      default: function (status) {
        return ''
      }
    },
    getPermitStatusClass: {
      type: Function,
      default: function (status) {
        return ''
      }
    }
  }
}
</script>

<style>
</style>
